export default __webpack_public_path__ + "static/media/talentpool-logo.8540b50a.png";